import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DL_DAYS_OF_WEEK } from 'src/app/services/DL/dl-schedule.service';
import { SchedulerAncComponent } from 'src/app/components/scheduler-anc/scheduler-anc.component';
import { AncDataService } from 'src/app/services/ANC/anc-data.service';
import { DeviceService } from 'src/app/services/devices/device.service';
import { getRelayOutputCount } from 'src/app/services/devices/device-type.util';
import { SuntimesService } from 'src/app/services/sunTimes/sunTimesLegacy.service';
import { OutButtonsComponent } from 'src/app/components/scheduler-anc/out-buttons/out-buttons.component';
import { ModalHolidayCalendarComponent } from 'src/app/components/ui/modal-holiday-calendar/modal-holiday-calendar.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ModalSchedulerGraphicComponent } from 'src/app/components/ui/modal-scheduler-graphic/modal-scheduler-graphic.component';
import { UtilsService } from 'src/app/services/utils/utils.service';
import tzLookup from 'tz-lookup';
import { HolidayConfig, RelayScheduleService } from 'src/app/services/utils/relaySchedule.service';


@Component({
    selector: 'app-anc-programs',
    imports: [CommonModule, FormsModule, TranslateModule, SchedulerAncComponent, OutButtonsComponent],
    templateUrl: './anc-programs.component.html',
    styleUrl: './anc-programs.component.scss'
})
export class AncProgramsComponent implements OnInit {
  @Input() allSettings: any;


  sunTimesData: any[] = [];
  device: string = '';
  deviceInfo: any;
  ancDeviceInfo: any;
  coordenadas: any;
  ubicacion: { country: string; city: string } | null = null;
  gmtMinutes: number = 0;
  selectedSunDate: string = '';
  selectedOutput: number = 1;
  programDataFormated: any[] = [];
  programdataFormatedOriginal: any[] = [];
  changesProgram = false
  changesHoliday = false;
  scheduleData: any[] = [];
  hideSchedulerAnc = false;
  editProgramIndex: number | null = null;
  editProgramDraft: any | null = null;
  holidayData: HolidayConfig = { enable: false, periods: [] };
  holidayEnable: boolean = false;
  originalHolidayData: any = null;
  viewMode: 'scheduler' | 'holiday' = 'scheduler';
  readonly daysOfWeek = DL_DAYS_OF_WEEK;
  private readonly weekdayKeys = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  newProgram : boolean = false;
  anyError: boolean = false;
  error: string = '';
  successMessage: boolean = false;
  loading: boolean = false;
  timeZone: string = '';
  highlightedProgramIndex: number | null = null;
  hoveredProgramId: number | null = null;
  editedProgramIds = new Set<number>();
  todayResult: any = null;
  totalsResult: any = null;
  dataSeason: any = null;

  private highlightTimeoutId: ReturnType<typeof setTimeout> | null = null;


  constructor(
    private route: ActivatedRoute,
    private suntimesService: SuntimesService,
    private _device: DeviceService,
    private _ancDataService: AncDataService,
    private _modalService: ModalService,
    public _utils: UtilsService,
    private _relayScheduleService: RelayScheduleService,
    private translate: TranslateService,
  ) {}

  private t(key: string, params?: Record<string, unknown>): string {
    return this.translate.instant(key, params);
  }

  getDayLabel(dayIndex: number): string {
    const key = this.weekdayKeys[dayIndex];
    return key ? this.t(key) : '';
  }

  getTypeLabel(type: number): string {
    switch (Number(type)) {
      case 0: return this.t('off');
      case 1: return this.t('on');
      case 2: return this.t('programKind_pulse');
      case 3: return this.t('programKind_cycle');
      default: return String(type);
    }
  }

  getModeLabel(mode: number): string {
    switch (Number(mode)) {
      case 1: return this.t('sunset');
      case 2: return this.t('sunrise');
      case 4: return this.t('programKind_redIni');
      case 8: return this.t('programKind_redEnd');
      case 16: return this.t('fixedTime');
      default: return String(mode);
    }
  }

  get outputCount(): number {
    return getRelayOutputCount(this.device);
  }

  getChannelLabel(channel: number): string {
    if (channel === 1) return 'C1';
    if (channel === 2) return 'C2';
    return this.t('channelBoth');
  }

  ngOnInit(): void {

    this.route.parent?.parent?.params.subscribe((params: Params) => (this.device = params['serial']));


    this._device.getModuleInfo(this.device, 'device').subscribe(deviceInfo => {
      this.ancDeviceInfo = deviceInfo.cfg;
      console.log('ANC DEVICE', this.ancDeviceInfo);

      this._device.getModuleInfo(this.device, "seasons").subscribe(data=>{
        this.dataSeason = data.cfg;
        console.log('dataSeason ', this.dataSeason);
      })


      this._device.getDeviceInfo(this.device).subscribe(deviceInfo => {
        this.deviceInfo = deviceInfo;
        const version = deviceInfo.hardware_version.split('.').pop() ?? '';
        this.coordenadas = this._ancDataService.getLocation(version, this.ancDeviceInfo.country, this.ancDeviceInfo.city);
        // console.log('coordenadas ', this.coordenadas);
        this.ubicacion = this._ancDataService.getCountryCityNames(version, this.ancDeviceInfo.country, this.ancDeviceInfo.city);
        // console.log('ubicacion ', this.ubicacion);


        // Calcular offset UTC real según la zona horaria del punto (evita heurística por meses)
        const now = new Date();
        const timeZone = tzLookup(this.coordenadas?.latitude ?? 0, this.coordenadas?.longitude ?? 0);
        this.timeZone = timeZone;

        const tzOffsetMinutes = this.dataSeason?.enable == 0 ? this.coordenadas?.gmtWinterMinutes : this.coordenadas?.gmtSummerMinutes;

        this.gmtMinutes = tzOffsetMinutes;

        this.selectedSunDate = this.getDateInputValueForTimeZone(now, this.timeZone);
        this.refreshSunTimesForSelectedDate();

        console.log('SunTimesData ', this.sunTimesData);
        console.log('Horarios Astronómicos para todo el año ', this.suntimesService.calculateSuntimesLegacyForYear(new Date().getFullYear(), this.gmtMinutes, this.coordenadas?.latitude ?? 0, this.coordenadas?.longitude ?? 0, 'es-ES'));

      });
    });

    this._device.getModuleInfo(this.device, "holiday").subscribe(data => {
      const formattedHolidayData = this._ancDataService.formatHolidayData(data.cfg);
      const hasEnabledPeriods = (formattedHolidayData.periods || []).some(
        (period: any) => Number(period?.enable ?? period?.enable) === 1
      );

      this.holidayData = {
        ...formattedHolidayData,
        enable: hasEnabledPeriods,
      };
      console.log('Holiday data ', this.holidayData);
      this.originalHolidayData = JSON.parse(JSON.stringify(this.holidayData));
      this.holidayEnable = hasEnabledPeriods;
    })
    this._device.getModuleInfo(this.device, "schedule").subscribe(data => {
      console.log('scheduler data ', data.cfg);
      this.programDataFormated = this._ancDataService.formatProgramData(data.cfg);
      this.programdataFormatedOriginal = JSON.parse(JSON.stringify(this.programDataFormated));
      this.scheduleData = this.programDataFormated;
      this.programDataFormated = (this.programDataFormated || []).map((item: any) => ({
        ...item,
        // Para input type="time" necesitamos HH:mm (sin negativos).
        // Aplica a modos con hora absoluta (16, 4 y 8).
        timeStr: this._utils.getDateFromMinutes([4, 8, 16].includes(Number(item?.mode)) ? Number(item?.time) || 0 : 0),
      }));
      console.log('programas formateados ', this.programDataFormated);
      console.log('holidayData', this.holidayData);
    })
    setTimeout(() => {
      // Retardo un poco la llamada para asegurar que se han cargado los datos necesarios
      this.timeRelayOn();
      console.log('Totales', this.totalsResult);

    }, 1000);
  }

    private getTimeZoneOffsetMinutes(date: Date, timeZone: string): number | null {
    if (!(date instanceof Date) || !Number.isFinite(date.getTime())) return null;
    if (!timeZone) return null;

    try {
      const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });

      const parts = dtf.formatToParts(date);
      const values: Record<string, string> = {};
      for (const p of parts) {
        if (p.type !== 'literal') values[p.type] = p.value;
      }

      const year = Number(values.year);
      const month = Number(values.month);
      const day = Number(values.day);
      const hour = Number(values.hour);
      const minute = Number(values.minute);
      const second = Number(values.second);
      if ([year, month, day, hour, minute, second].some(n => !Number.isFinite(n))) return null;

      const asUTC = Date.UTC(year, month - 1, day, hour, minute, second);
      return Math.round((asUTC - date.getTime()) / 60000);
    } catch {
      return null;
    }
  }

  onOutputChange(output: number): void {
    this.selectedOutput = this.outputCount === 1 ? 1 : output;
  }

  onSchedulerDragChange(change: { programId: number; time: number; valueKind: 'absolute' | 'offset'; isFinal?: boolean }): void {
    const programId = Number(change?.programId);
    const nextTime = Math.trunc(Number(change?.time) || 0);
    const isFinal = change?.isFinal === true;

    if (!Number.isFinite(programId)) return;

    const updatedIndex = (this.programDataFormated || []).findIndex((program: any) => {
      const mode = Number(program?.mode);
      return Number(program?.id) === programId && [1, 2, 4, 8, 16].includes(mode);
    });

    this.programDataFormated = (this.programDataFormated || []).map((program: any) => {
      if (Number(program?.id) !== programId) return program;

      const mode = Number(program?.mode);
      if (![1, 2, 4, 8, 16].includes(mode)) return program;

      if ((mode === 1 || mode === 2) && change.valueKind === 'offset') {
        return {
          ...program,
          time: nextTime,
        };
      }

      if (![4, 8, 16].includes(mode) || change.valueKind !== 'absolute') return program;

      const minutes = Math.max(0, Math.min(1439, nextTime));

      return {
        ...program,
        time: minutes,
        timeStr: this._utils.getDateFromMinutes(minutes),
      };
    });

    if (Number.isInteger(updatedIndex) && updatedIndex >= 0) {
      this.highlightedProgramIndex = updatedIndex;
    }

    if (isFinal) {
      this.touchProgramData();
      this.markProgramAsEdited(programId);
      this.highlightProgramRow(updatedIndex);
    }
  }

  ngOnDestroy(): void {
    if (this.highlightTimeoutId) {
      clearTimeout(this.highlightTimeoutId);
      this.highlightTimeoutId = null;
    }
  }

  private highlightProgramRow(index: number): void {
    if (!Number.isInteger(index) || index < 0) return;

    this.highlightedProgramIndex = index;

    if (this.highlightTimeoutId) {
      clearTimeout(this.highlightTimeoutId);
    }

    this.highlightTimeoutId = setTimeout(() => {
      this.highlightedProgramIndex = null;
      this.highlightTimeoutId = null;
    }, 2500);
  }

  isProgramEdited(programId: unknown): boolean {
    const id = Number(programId);
    return Number.isFinite(id) && this.editedProgramIds.has(id);
  }

  onProgramRowEnter(item: any): void {
    const id = Number(item?.id);
    this.hoveredProgramId = Number.isFinite(id) && id >= 0 ? id : null;
  }

  onProgramRowLeave(): void {
    this.hoveredProgramId = null;
  }

  private markProgramAsEdited(programId: number): void {
    if (!Number.isFinite(programId) || programId < 0) return;
    this.editedProgramIds.add(programId);
    this.changesProgram = true;
  }


    addPeriod(): void {
      this.changesHoliday = true;
      this.holidayEnable = true;
      console.log('holidaydata.length ',this.holidayData.periods.length);
      if (this.holidayData.periods.length >= 4 && this.holidayData.periods.every(period => period.enable)) {
        return; // No se pueden añadir más de 4 periodos
      }

      for (const period of this.holidayData.periods) {
        if (!period.enable) {
          period.enable = 1; // Activar el primer periodo desactivado encontrado
          this.openCalendarModal(this.holidayData.periods.indexOf(period));
          break;
        }
      }

      // Añadir un nuevo periodo con valores por defecto
      // this.holidayData.periods.push({
      //   startDay: 1,
      //   startMonth: 1,
      //   startHour: '00:00',
      //   endDay: 1,
      //   endMonth: 1,
      //   endHour: '00:00',
      //   autoreload: 0,
      //   enable: 1
      // });
      // this.openCalendarModal(this.holidayData.periods.length - 1);

    }

    deletePeriod(index: number): void {
      this.changesHoliday = true;
      console.log('delete periodo ', this.holidayData.periods[index]);
      this.holidayData.periods[index].enable = 0;
      console.log('delete periodo ', this.holidayData.periods[index]);
      // this.holidayData.periods.splice(index, 1);
    }

    openCalendarModal(editSelectedIndex?: number): void {

      const modalRef = this._modalService.open(ModalHolidayCalendarComponent, {
        centered: true,
        scrollable: true,
        size: 'xl',
        fullscreen: true
      });
      modalRef.componentInstance.holidayData = this.holidayData.periods;
      if (editSelectedIndex !== undefined) {
        modalRef.componentInstance.selectedIndex = editSelectedIndex;
      }

      modalRef.result.then(
        (result) => {
          // Modal closed with data
          this.holidayData.periods = result;
          this.changesHoliday = true;
          this.changesHoliday = true;
          console.log('Holiday data actualizado desde modal:', this.holidayData);
        },
        () => {
          // Modal dismissed without save
          console.log('Calendar modal cerrado sin cambios');
        }
      );
    }

      // Función para abrir el modal de programación
      openSchedulerModal(): void {
        // Hide the background scheduler component to avoid canvas/icon overlap
        this.hideSchedulerAnc = true;

        const modalRef = this._modalService.open(ModalSchedulerGraphicComponent, {
          centered: true,
          scrollable: true,
          windowClass: 'scheduler-window' // clase que usarás en el CSS
        });

        modalRef.componentInstance.serial = this.device;
        modalRef.componentInstance.schedulerData = this.programDataFormated;
        modalRef.componentInstance.selectedOutput = this.selectedOutput;
        // Pass sunTimesData (calculated array with real astronomical data)
        modalRef.componentInstance.sunTimes = this.sunTimesData;

        modalRef.result.then(
          (result) => {
            // Modal closed with save
            this.programDataFormated = result;
            this.timeRelayOn();
            console.log('Modal cerrado con resultado:', result);
            this.hideSchedulerAnc = false;
            // try {
            //   this.schedulerAnc?.resumeRendering();
            // } catch (e) {
            //   console.warn('Failed to resume schedulerAnc rendering', e);
            // }
          },
          () => {
            // Modal dismissed without save
            console.log('Modal cerrado sin cambios');
            this.hideSchedulerAnc = false;
            try {
              console.log('data tas cerrar el modal ', this.programDataFormated);

              // this.schedulerAnc?.resumeRendering();
            } catch (e) {
              console.warn('Failed to resume schedulerAnc rendering', e);
            }
          }
        );
      }

  isDaySelected(daymask: unknown, dayValue: number): boolean {
    const mask = Number(daymask) || 0;
    return (mask & dayValue) !== 0;
  }

  toggleDay(program: any, dayValue: number): void {
    if (!program) return;
    const mask = Number(program.daymask) || 0;
    program.daymask = (mask ^ dayValue) & 0x7f;
  }


  setEditProgramIndex(index: number): void {
    this.editProgramIndex = index;
    const item = this.programDataFormated?.[index];
    this.editProgramDraft = item ? { ...item } : null;

    if (!this.editProgramDraft) return;

    if (this.outputCount === 1) {
      this.editProgramDraft.channel = 1;
    }

    const mode = Number(this.editProgramDraft.mode);
    const minutes = Math.trunc(Number(this.editProgramDraft.time) || 0);

    // Campos auxiliares solo para el modal (inputs type="time" no admiten valores negativos)
    this.editProgramDraft.fixedTimeStr = this._utils.getDateFromMinutes(Math.abs(minutes));
    this.editProgramDraft.correctionSign = minutes < 0 ? -1 : 1;
    this.editProgramDraft.correctionStr = this._utils.getDateFromMinutes(Math.abs(minutes));

    // Mantener compatibilidad con el resto de la vista
    if (mode === 16) {
      this.editProgramDraft.timeStr = this._utils.getDateFromMinutes(Math.abs(minutes));
    }
  }

  saveEditProgram(): void {
    if (this.editProgramIndex === null || !this.editProgramDraft) return;
    const current = this.programDataFormated?.[this.editProgramIndex];
    if (!current) return;

    const mode = Number(this.editProgramDraft.mode);
    let next: any = { ...current, ...this.editProgramDraft };

    if (this.outputCount === 1) {
      next.channel = 1;
    }

    if ([4, 8, 16].includes(mode)) {
      const minutes = this.minutesFromTimeInput(this.editProgramDraft.fixedTimeStr ?? this.editProgramDraft.timeStr);
      if (minutes !== null) {
        next.time = minutes;
        next.timeStr = this._utils.getDateFromMinutes(minutes);
      }
    }

    if (mode === 1 || mode === 2) {
      const baseMinutes = this.minutesFromTimeInput(this.editProgramDraft.correctionStr);
      if (baseMinutes !== null) {
        const sign = Number(this.editProgramDraft.correctionSign) === -1 ? -1 : 1;
        next.time = baseMinutes * sign;
        next.timeStr = this._utils.getDateFromMinutes(next.time);
      }
    }

    // No persistimos campos auxiliares del modal en el array principal
    const { fixedTimeStr, correctionSign, correctionStr, ...clean } = next;
    this.programDataFormated[this.editProgramIndex] = clean;

    this.touchProgramData();
    this.markProgramAsEdited(Number(clean?.id));
    this.highlightProgramRow(this.editProgramIndex);

    this.newProgram = false;
  }

  private minutesFromTimeInput(value: unknown): number | null {
    if (typeof value !== 'string') return null;
    const match = value.trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
    return hours * 60 + minutes;
  }


  addProgram(): void {
    const newProgram = {
      id : this.programDataFormated.length,
      type: 1,
      channel: this.outputCount === 1 ? 1 : 3,
      mode: 16,
      time: 0,
      daymask: 127,
      festive: 0,
      timeStr: '00:00'
    };
    this.programDataFormated.push(newProgram);
    this.touchProgramData();
    this.markProgramAsEdited(Number(newProgram.id));
    this.highlightProgramRow(this.programDataFormated.length - 1);
    this.setEditProgramIndex(this.programDataFormated.length - 1);
    this.changesProgram = true;
  }

  deleteProgram(index: number): void {
    if (!Array.isArray(this.programDataFormated)) return;
    if (index < 0 || index >= this.programDataFormated.length) return;
    // Marcamos el programa como  id=-1 y el resto de valores a 0 para eliminarlo
    this.programDataFormated[index] = {
      id: -1,
      type: 0,
      channel: 0,
      mode: 0,
      time: 0,
      daymask: 0,
      festive: 0,
      timeStr: '00:00'
    }

    // this.programDataFormated.splice(index, 1);
    this.touchProgramData();
  }

  cancelNewProgram(): void {
    if (!this.newProgram) return;
    this.programDataFormated.pop();
    this.touchProgramData();
    this.newProgram = false;
    this.changesProgram = false;
  }

  private touchProgramData(): void {
    // Crea nueva referencia y elimina los programas marcados con id = -1
    this.scheduleData = (this.programDataFormated || []).filter((program: any) => Number(program?.id) !== -1);
    this.timeRelayOn();
  }

  saveProgram(): void {
    this.loading = true;
    this.programDataFormated = (this.programDataFormated || []).map((program: any) => {
      const mode = Number(program?.mode);
      if (![4, 8, 16].includes(mode)) return program;

      const minutes = this.minutesFromTimeInput(program?.timeStr);
      if (minutes === null) return program;

      return {
        ...program,
        time: minutes,
        timeStr: this._utils.getDateFromMinutes(minutes),
      };
    });

    this.touchProgramData();
    console.log('Programas que hay grabar ', this.programDataFormated);
    const rawData = []
    for (const program of this.programDataFormated) {
      const raw = this.programToRaw(program);
      rawData.push(raw);
    }
    console.log('Progamas en crudo a grabar ', rawData);
    rawData.forEach((raw, index) => {
      const body = {
        [`${index}`]: raw
      }
      console.log('body', body);
      this._device.setModuleCfg(this.device, body, 'schedule').subscribe(data => {
        console.log('respuesta al grabar el programa ', data);
        this.successMessage = true;
        this.editedProgramIds.clear();
        this.highlightedProgramIndex = null;
         setTimeout(() => {
          this.successMessage = false;
        }, 3000);
      },
      error => {
        this.error = this.t('programSaveError');
        this.anyError = true;
        setTimeout(() => {
          this.error = '';
        }, 3000);
      }
       );
    });
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }

 programToRaw(program: any): number[] {
  const raw = new Array(19).fill(0);

  const timeBytes = this.int32ToBytes(program.time);

  raw[0] = timeBytes[0];
  raw[1] = timeBytes[1];
  raw[2] = timeBytes[2];
  raw[3] = timeBytes[3];

  raw[4] = program.id;
  raw[5] = program.channel;
  raw[6] = program.type;
  raw[7] = program.mode;
  raw[8] = program.daymask;
  raw[9] = program.festive;

  return raw;
}

 int32ToBytes(value: number): number[] {
  return [
    (value >> 24) & 0xff,
    (value >> 16) & 0xff,
    (value >> 8) & 0xff,
    value & 0xff
  ];
}


  restoreProgram(): void {
    this.changesProgram = false;
    this.programDataFormated = JSON.parse(JSON.stringify(this.programdataFormatedOriginal));
    this.scheduleData = this.programDataFormated;
    this.touchProgramData();
    this.editedProgramIds.clear();
    this.highlightedProgramIndex = null;
  }

  restoreHoliday(): void {
    this.changesHoliday = false;
    this.holidayData = JSON.parse(JSON.stringify(this.originalHolidayData));
  }

  saveHoliday(): void {
    this.loading = true;
    const body: { [key: string]: number[] } = {};
    for (const holiday of this.holidayData.periods) {
      const raw = this.holidayToRaw(holiday);
      Object.assign(body, raw);
    }
    this._device.setModuleCfg(this.device, body, 'holiday').subscribe(
      () => {
        // Nueva referencia para disparar ngOnChanges en el scheduler
        this.holidayData = { ...this.holidayData };
        this.originalHolidayData = JSON.parse(JSON.stringify(this.holidayData));
        this.changesHoliday = false;
        this.successMessage = true;
        this.loading = false;
        setTimeout(() => {
          this.successMessage = false;
        }, 3000);
      },
      () => {
        this.error = this.t('holidaySaveError');
        this.anyError = true;
        this.loading = false;
        setTimeout(() => {
          this.error = '';
        }, 3000);
      }
    );
  }

holidayToRaw(holiday: any): { [key: string]: number[] } {
  console.log('Holiday en proceso raw ', holiday);
  const raw = new Array(9)

  raw[0] = holiday.startDay;

  raw[1] = holiday.startMonth ;
  raw[2] = holiday.startHour;
  raw[3] = holiday.startMinute;

  raw[4] = holiday.endDay ;
  raw[5] = holiday.endMonth ;
  raw[6] = holiday.endHour;
  raw[7] = holiday.endMinute;

  raw[8] = holiday.enable ;

  return { [`period${holiday.period}`]: raw };
}

  setQuickPreset(type: 'weekdays' | 'weekend' | 'allDays'): void {
    if (!this.editProgramDraft) return;

    const presetDayMask: Record<'weekdays' | 'weekend' | 'allDays', number> = {
      weekdays: 64 + 32 + 16 + 8 + 4,
      weekend: 2 + 1,
      allDays: 127,
    };

    this.editProgramDraft.daymask = presetDayMask[type];
  }

// Bloque para visualizar rápidamente los cambios en el gráfico de programación al modificar la fecha base o la zona horaria
  goToTodaySunDate(): void {
    this.selectedSunDate = this.getDateInputValueForTimeZone(new Date(), this.timeZone);
    this.refreshSunTimesForSelectedDate();
  }

  shiftSunDate(days: number): void {
    const base = this.getDateFromInput(this.selectedSunDate);
    if (!base) return;

    const next = new Date(base);
    next.setDate(next.getDate() + Math.trunc(days || 0));
    this.selectedSunDate = this.getDateInputValue(next);
    this.refreshSunTimesForSelectedDate();
  }

  onSunDateChange(): void {
    this.refreshSunTimesForSelectedDate();
  }

  private refreshSunTimesForSelectedDate(): void {
    const baseDate = this.getDateFromInput(this.selectedSunDate);
    if (!baseDate || !this.timeZone) return;


    this.sunTimesData = this.suntimesService.calculateSuntimesLegacyForWeek(
      baseDate,
      this.gmtMinutes,
      this.coordenadas?.latitude ?? 0,
      this.coordenadas?.longitude ?? 0
    );
  }

  private getDateFromInput(value: string): Date | null {
    if (typeof value !== 'string') return null;
    const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (![year, month, day].every(Number.isFinite)) return null;

    const d = new Date(year, month - 1, day, 12, 0, 0, 0);
    if (
      d.getFullYear() !== year ||
      d.getMonth() !== (month - 1) ||
      d.getDate() !== day
    ) {
      return null;
    }

    return d;
  }

  private getDateInputValue(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private getDateInputValueForTimeZone(date: Date, timeZone: string): string {
    if (!timeZone) return this.getDateInputValue(date);

    try {
      const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });

      const parts = dtf.formatToParts(date);
      const values: Record<string, string> = {};
      for (const p of parts) {
        if (p.type !== 'literal') values[p.type] = p.value;
      }

      const year = Number(values.year);
      const month = Number(values.month);
      const day = Number(values.day);
      if (![year, month, day].every(Number.isFinite)) return this.getDateInputValue(date);

      return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    } catch {
      return this.getDateInputValue(date);
    }
  }

  timeRelayOn(){

      const astroYear = this.suntimesService.calculateSuntimesLegacyForYear(new Date().getFullYear(), this.gmtMinutes, this.coordenadas?.latitude ?? 0, this.coordenadas?.longitude ?? 0, 'es-ES');
      this.todayResult = this._relayScheduleService.getRelayScheduleForToday(
        this.programDataFormated,
        astroYear,
        this.holidayData as HolidayConfig
      );

      const currentYear = new Date().getFullYear();
       this.totalsResult = this._relayScheduleService.getRelayOperatingTotalsForRange(
        this.programDataFormated,
        astroYear,
        `${currentYear}-01-01`,
        `${currentYear}-12-31`,
        this.holidayData as HolidayConfig
      );
  }

}
